<template>
  <div class="t_scroll" id="tyg_scroll" @mouseover="stopScroll" @mouseout="restartscroll">
    <!-- <div class="inner_content" v-for="(item, index) in scrolldata" :key="index">
      <p>{{ item }}</p>
    </div> -->
    <div
      v-for="(item, i) in scrolldata"
      v-bind:key="i"
      class="slideItem"
      @click="renderPlay(item)"
    >
      <p class="content">{{ "预测点位：" + item.deviceName }}</p>
      <strong class="title">{{ "预测浓度：" + item.value + "μg/m³" }}</strong>
      <p class="content">
        {{ "预测时间：" + getTimeFormat(item.time) }}
      </p>
    </div>

    <slot name="div_title"></slot>
  </div>
</template>

<script>
import { reactive, ref, computed, watch, getCurrentInstance } from "vue";
// import hljs from "highlight.js";
export default {
  props: {
    data_scroll: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  setup(props, ctx) {
    let scrolldata = reactive([]);
    const ss = props.data_scroll;
    const scroll_top = () => {
      let element = document.getElementById("tyg_scroll");
      if (element) {
        let hScrollTop = element.scrollTop;
        let hScrollHeight = element.scrollHeight;
        let elHeight = element.offsetHeight;
        let height = 1;
        if (height + hScrollTop >= hScrollHeight - elHeight) {
          //滚动条已经到了容器底
          if (timer.value) {
            clearInterval(timer.value);
            timer.value = null;
            element.scrollTop = 0;
            initTimer();
          }
        } else {
          var h = hScrollTop + height;
          element.scrollTop = h;
        }
      }
    };
    const timer = ref(null);
    watch(() => props.data_scroll, (newval, oldval) => {
      if(newval.length) {
        newval.forEach((el) => {
          scrolldata.push(el);
        });
      } else {
        scrolldata.length = 0;
      }
      if (newval.length > 0) {
        let element = document.getElementById("tyg_scroll");
        element.scrollTop = 0;
        initTimer();
      }
      console.log(newval, scrolldata, 'globalpredicts')

    }, { deep: true });
    const initTimer = () => {
      if (timer.value) {
      } else {
        timer.value = setInterval(() => {
          scroll_top();
        }, 30);
      }
    };
    const stopScroll = () => {
      if (timer.value) {
        let element = document.getElementById("tyg_scroll");
        let hScrollTop = element.scrollTop;
        clearInterval(timer.value);
        timer.value = null;
      }
    };
    const restartscroll = () => {
      initTimer();
    };
    const getTimeFormat = computed(() => {
      return (timeStr) => {
        return new Date(timeStr.toString().replace(/-0/g, "/").replace(/-/g, "/")).Format(
          "hh:mm:ss"
        );
      };
    });
    const renderPlay = (data) => {
      ctx.emit("renderPlay", data);
    };
    return {
      stopScroll,
      scrolldata,
      restartscroll,
      getTimeFormat,
      renderPlay,
    };
  },
};
</script>
<style lang="scss" scoped>
.t_scroll {
  width: 100%;
  height: 280px;
  overflow: hidden;
  overflow-y: auto;
  pointer-events: initial;
}
.inner_content {
  width: 100%;
  height: 30px;
  overflow: hidden;
  outline: 1px solid red;
}
.slideItem {
  font-size: 24px;
  font-family: "normalFont";
  line-height: 42px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
  // padding-bottom: 10px;

  .title {
    color: #f4c48f;
  }

  .content {
    color: #99f5ff;
  }
}
</style>
